App.directive('healthPzuwPersonFormTpl', ['Config', function (Config) {
    function FormTplCtrl($scope, $rootScope) {
        var self = this;

        self.$onInit = function () {
            $scope.model.sameAddress = !!$scope.addressToApply;
            if ($scope.isHealth && !$rootScope.CONFIGURATOR.healthInsurance.canAddSiblings) {
                $scope.withSibling = false;
                $scope.model['member'] = 'CHILD';
            }

            $scope.notExistEmail = !!$scope.isNullableEmail;

            $scope.$watch('notExistEmail', function (oldVal, newVal) {
                if (oldVal !== newVal) {
                    if ($scope.notExistEmail) {
                        $scope.model.email = '';
                    }
                }
            });
        };

        self.$onChanges = function (changes) {
            if (changes && changes.addressToApply) {
                $scope.model.sameAddress = !!$scope.addressToApply;
            }
            console.log('[formTpl] [$onChanges]', changes, $scope.model.sameAddress);
        };
    }
    FormTplCtrl.$inject = ['$scope', '$rootScope'];

    return {
    	restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            withSibling: '<?',
            addressToApply: '<?',
            isHealth: '<?',
            isNullableEmail: '<?'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/health-pzuw-person-form-tpl.html',
        controller: FormTplCtrl
    };
}]);
